import GenericMessage from './GenericMessage'

export default GenericMessage
// eslint-disable-next-line import/export
export * from './GenericMessage'
